import { CommonModule } from "@angular/common";
import { Component, EventEmitter, Input, Output } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { environment } from "src/environments/environment";
import { SharedModule } from "src/shared/shared.module";
import { PipesModule } from "src/utils/pipes/pipes.module";

@Component({
  selector: "app-cart-item",
  imports: [CommonModule, SharedModule, PipesModule, TranslateModule],
  templateUrl: "./cart-item.component.html",
  styleUrl: "./cart-item.component.scss",
})
export class CartItemComponent {
  @Input() course_item: any;
  @Input() can_delete: boolean = true;

  @Output() onDelete = new EventEmitter();

  fileUrl = environment.apiFileUrl;

  deleteItem(id: number) {
    this.onDelete.emit(id);
  }
}
